import { Component } from '@angular/core'
import { IConversationVM, openConversationFilter } from '@engineering11/messaging-web'
import { ConversationTypes, IEmployerConversationVM } from 'shared-lib'

@Component({
  selector: 'nav-item-direct-messages',
  templateUrl: './direct-messages-nav.component.html',
  styleUrls: ['./direct-messages-nav.component.scss'],
})
export class DirectMessagesNavComponent {
  ConversationTypes = ConversationTypes
  groupFn: (obj: IConversationVM) => string = (obj: IEmployerConversationVM) =>
    obj.clientMetadata?.jobPostId ?? obj.clientMetadata?.jobPostName ?? obj.shortName // TODO: Address missing value
  groupNameFn: (obj: IConversationVM) => string = (obj: IEmployerConversationVM) => obj.clientMetadata?.jobPostName ?? obj.shortName // TODO: Address missing value
  groupSubtitleFn: (obj: IConversationVM) => string = (obj: IEmployerConversationVM) => obj.clientMetadata?.location?.name ?? ''
  openConversationFilter = openConversationFilter
}
